import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { footerData } from "../../data/companyData";

const {
  variant,
  className,
  description,
  contactInfo = {},
  columns = [],
  socialLinks = [],
  showAppLinks,
} = footerData;

const Footer = () => {
  const navigate = useNavigate();
  const getContactIconClasses = () => {
    return "text-primary-600 text-2xl";
  };

  const getSocialIconClasses = () => {
    return "text-primary-600 text-2xl";
  };

  const getFooterClasses = () => {
    return `py-8  ${className}`;
  };

  return (
    <footer
      className={`border-t border-neutral-800 bg-neutral-900 ${getFooterClasses()}`}
    >
      <div className="container mx-auto px-4">
        <div className="flex flex-wrap items-start gap-8 justify-between">
          {/* Left: Company Info (fixed) */}
          <div
            className={`flex-none min-w-62.5 ${
              variant === "two" ? "max-w-68.75" : "w-64"
            }`}
          >
            <div className="">
              <Link to="/" className="inline-block">
                <img
                  src="/assets/Images/logo/blackstore.png"
                  alt="BlackStore"
                  className="h-20"
                />
              </Link>
            </div>
            <p className="mb-6 text-sm text-neutral-400">{description}</p>

            {/* Contact Information */}
            <div className="space-y-4">
              {contactInfo.addressOne && (
                <div className="flex items-center gap-4">
                  <span className={getContactIconClasses()}>
                    <i className="ph-fill ph-map-pin" />
                  </span>
                  <span className="text-sm text-neutral-400">
                    {contactInfo.addressOne}
                  </span>
                </div>
              )}
              <div className="space-y-4">
                {contactInfo.addressTwo && (
                  <div className="flex items-center gap-4">
                    <span className={getContactIconClasses()}>
                      <i className="ph-fill ph-map-pin" />
                    </span>
                    <span className="text-sm text-neutral-400">
                      {contactInfo.addressTwo}
                    </span>
                  </div>
                )}
              </div>
              {contactInfo.phones && contactInfo.phones.length > 0 && (
                <div className="flex items-center gap-4">
                  <span className={getContactIconClasses()}>
                    <i className="ph-fill ph-phone-call fs" />
                  </span>
                  <div className="flex items-center gap-2 flex-wrap">
                    {contactInfo.phones.map((phone, index) => (
                      <React.Fragment key={phone}>
                        <Link
                          to={`tel:${phone}`}
                          className="text-sm text-neutral-400 hover:text-primary transition-colors"
                        >
                          {phone}
                        </Link>
                        {index < contactInfo.phones!.length - 1 && (
                          <span className="text-sm text-primary-600">or</span>
                        )}
                      </React.Fragment>
                    ))}
                  </div>
                </div>
              )}

              {contactInfo.email && (
                <div className="flex items-center gap-4">
                  <span className={getContactIconClasses()}>
                    <i className="ph-fill ph-envelope" />
                  </span>
                  <Link
                    to={`mailto:${contactInfo.email}`}
                    className="text-sm text-neutral-400 hover:text-primary transition-colors"
                  >
                    {contactInfo.email}
                  </Link>
                </div>
              )}
            </div>
          </div>

          {/* Center: Grouped Columns (centered) */}
          <div className="flex-1 flex sm:justify-center">
            <div className="flex gap-8 flex-wrap justify-center">
              {columns.map((column, index) => (
                <div key={index} className="w-44 min-w-40">
                  <h6 className="text-lg font-semibold mb-4 text-white">
                    {column.title}
                  </h6>
                  <ul className="space-y-3">
                    {column.links.map((link, linkIndex) => (
                      <li key={linkIndex}>
                        <Link
                          onClick={(e) => {
                            e.preventDefault();
                            // Ensure absolute path navigation
                            const to = link.href.startsWith("/")
                              ? link.href
                              : `/${link.href}`;
                            navigate(to, { replace: false });
                          }}
                          className="text-sm text-neutral-400 hover:text-primary transition-colors cursor-pointer"
                          to={""}
                        >
                          {link.label}
                        </Link>
                      </li>
                    ))}
                  </ul>
                </div>
              ))}
            </div>
          </div>

          {/* Right: App Links & Social (fixed) */}
          <div className="flex-none min-w-50 w-56">
            {showAppLinks && (
              <>
                <h6 className="text-lg font-semibold mb-4 text-white">
                  Shop on The Go
                </h6>
                <p className="mb-4 text-sm text-neutral-400">
                  Yaghi Store is behind you , let's shop now
                </p>
              </>
            )}

            {/* Social Links */}
            <ul className="flex items-center gap-3 mt-6">
              {socialLinks.map((social, index) => (
                <li key={index}>
                  <Link
                    to={social.url}
                    className={getSocialIconClasses()}
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label={social.name}
                  >
                    <i className={`ph-fill ${social.icon}`} />
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* Bottom Footer */}
        <div className="border-t border-neutral-800 pt-6 mt-8">
          <div className="container flex-row sm:flex justify-center sm:justify-between  items-center mx-auto px-4">
            <div className="flex justify-center sm:justify-start items-center flex-wrap gap-4">
              <p className="text-sm text-neutral-500 m-0">
                © {new Date().getFullYear()} BlackStore. All rights reserved.
              </p>
            </div>
            <div className="flex sm:justify-end justify-center items-center flex-wrap gap-4 mt-3 sm:mt-0">
              <p className="text-sm text-neutral-500 m-0">
                Powered by
                <span className="inline-block mx-1">
                  <button
                    onClick={() =>
                      window.open("https://www.nawaah.org/", "_blank")
                    }
                  >
                    <img
                      src="https://rmwaekdegldiwbziheqr.supabase.co/storage/v1/object/public/publicimages/nawah_logo/nawah_logo.png"
                      alt="nawah logo"
                      className="inline-block h-7 invert"
                    />
                  </button>
                </span>
              </p>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
